var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainTemplate',[_c('div',{staticClass:"user container"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t('user')))]),_c('div',{staticClass:"page-content"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }